/** Completion status as the backend computes it. Mirrors
 *  backend/apps/tutor/analytics/completion.py::BiteStatus exactly. */
export enum BiteStatus {
  COMPLETED = "completed",
  INCOMPLETE = "incomplete",
  NOT_STARTED = "not_started",
  SKIPPED_BY_USER = "skipped_by_user",
  SKIPPED_BY_AI = "skipped_by_ai",
}

/** What a bite tile is painted and labelled as. Derived by resolveDisplayState
 *  from BiteStatus + TutorSupportLevel; never sent by the backend. Mutually
 *  exclusive — "last learned" is a modifier on top of one of these, not a member,
 *  since a bite can be completed and last-viewed at the same time. */
export enum BiteDisplayState {
  // Completed: the four analysed levels, plus the case where no analysis landed.
  FLAWLESS = "flawless",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  NOT_ANALYZED = "not_analyzed",

  PROCESSING = "processing",
  INCOMPLETE = "incomplete",
  NOT_STARTED = "not_started",
}

export enum TutorSupportLevel {
  FLAWLESS = "flawless",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export enum MasteryLevel {
  NOT_STARTED = "not_started",
  APPROACHING = "approaching",
  PROFICIENT = "proficient",
  MASTERED = "mastered",
}
